import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "space-y-0" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

interface TocLink {
  id: string;
  text: string;
  depth: number;
  children?: TocLink[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogToc',
  props: {
    links: {},
    highlight: { type: Boolean, default: true },
    highlightColor: { default: "primary" },
    color: { default: "neutral" }
  },
  setup(__props: any) {

const props = __props;

const activeId = ref<string | null>(null);

onMounted(() => {
  if (!props.highlight) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activeId.value = entry.target.id;
        }
      });
    },
    {
      rootMargin: "-80px 0px -80% 0px",
    },
  );

  props.links.forEach((link) => {
    const el = document.getElementById(link.id);
    if (el) observer.observe(el);
    link.children?.forEach((child) => {
      const childEl = document.getElementById(child.id);
      if (childEl) observer.observe(childEl);
    });
  });

  onUnmounted(() => observer.disconnect());
});

const scrollToHeading = (id: string) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const getIndentClass = (depth: number) => {
  switch (depth) {
    case 2:
      return "pl-0";
    case 3:
      return "pl-2";
    case 4:
      return "pl-4";
    default:
      return "pl-0";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "text-[11px] font-semibold text-neutral-400 dark:text-neutral-500 uppercase tracking-wide mb-1" }, " On this page ", -1)),
    _createElementVNode("nav", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: link.id
        }, [
          _createElementVNode("button", {
            class: _normalizeClass([
            'block text-[13px] transition-colors duration-150 w-full text-left py-0.5 rounded px-1 -ml-1',
            getIndentClass(link.depth),
            _unref(activeId) === link.id && __props.highlight
              ? 'text-primary-600 dark:text-primary-400 font-medium bg-primary-50/80 dark:bg-primary-950/40'
              : 'text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-200',
          ]),
            onClick: ($event: any) => (scrollToHeading(link.id))
          }, _toDisplayString(link.text), 11, _hoisted_2),
          (link.children?.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(link.children, (child) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: child.id,
                  class: _normalizeClass([
              'block text-[13px] transition-colors duration-150 w-full text-left py-0.5 rounded px-1 -ml-1',
              getIndentClass(child.depth),
              _unref(activeId) === child.id && __props.highlight
                ? 'text-primary-600 dark:text-primary-400 font-medium bg-primary-50/80 dark:bg-primary-950/40'
                : 'text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-200',
            ]),
                  onClick: ($event: any) => (scrollToHeading(child.id))
                }, _toDisplayString(child.text), 11, _hoisted_3))
              }), 128))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _renderSlot(_ctx.$slots, "bottom")
  ]))
}
}

})